import APIUrl from "../../../APIUrl";
import axios from "axios";

export const GET_COMPANY = "GET_COMPANY";

export function getCompanyAction(company) {
  return { type: GET_COMPANY, company: company };
}

export const checkIfCompanyUrlExists = function (
  url,
  existsCallback,
  noExistsCallback,
) {
  return axios
    .get(APIUrl.checkIfCompanyUrlExists + url)
    .then(function (response) {
      if (response && response.status === 200) {
        if (existsCallback) existsCallback();
      } else {
        if (noExistsCallback) noExistsCallback();
      }
    });
};

export const checkIfSerialNumberExists = function (
  serialNumber,
  existsCallback,
  noExistsCallback,
) {
  return axios
    .get(APIUrl.checkIfSerialNumberExists + serialNumber)
    .then(function (response) {
      if (response && response.status === 200) {
        if (existsCallback) existsCallback(response.data);
      } else {
        if (noExistsCallback) noExistsCallback();
      }
    });
};

export const testCompanyCrmSettings = function (
  data,
  successCallback,
  failureCallback,
) {
  if (data === false) {
    failureCallback("Erreur de data");
  } else {
    return function (dispatch) {
      return axios
        .post(APIUrl.testCompanyCrmSettings, data)
        .then(function (response) {
          dispatch(getCompany());
          if (response.status === 202 || response.status === "202") {
            return failureCallback(response.status, response.data);
          } else {
            return successCallback(response.status, response.data);
          }
        })
        .catch(function (err) {
          throw err;
        });
    };
  }
};

export const createCompany = function (data, successCallback, failureCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.createCompany, data)
      .then(function (response) {
        if (response) dispatch(getCompany());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const updateCompany = function (data, successCallback, failureCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.updateCompany, data)
      .then(function (response) {
        if (response) dispatch(getCompany());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const deleteCompanyCrm = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteCompanyCrm, data)
      .then(function (response) {
        if (response) dispatch(getCompany());
        if (successCallback) successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const updateCompanyCrmByField = function (
  data,
  successCallback,
  failureCallback,
) {
  return function (dispatch) {
    return axios
      .post(APIUrl.updateCompanyCrmByField, data)
      .then(function (response) {
        if (response) dispatch(getCompany());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const updateCompanyCrm = function (
  data,
  successCallback,
  failureCallback,
) {
  return function (dispatch) {
    return axios
      .post(APIUrl.updateCompanyCrm, data)
      .then(function (response) {
        if (response) dispatch(getCompany());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const getCompany = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getCompany)
      .then(function (response) {
        if (response) {
          dispatch(getCompanyAction(response.data));
        }
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const blockCompany = function (company_id) {
  return function (dispatch) {
    return axios
      .post(APIUrl.blockCompany, company_id)
      .then(function (response) {
        if (response) dispatch(getCompany());
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const checkIfDeskVideoExists = function (
  companyId,
  existsCallback,
  noExistsCallback,
) {
  return axios
    .get(APIUrl.checkIfDeskVideoExists + companyId)
    .then(function (response) {
      if (response && response.status === 200) {
        if (existsCallback) existsCallback();
      } else {
        if (noExistsCallback) noExistsCallback();
      }
    });
};

export const addDeskVideo = function (companyId, data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.addDeskVideo + companyId, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (response) {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        throw err;
      });
  };
};
